export const logDataToConsole = (
  message = "",
  valueToLog: unknown = "",
  loggerType: "info" | "warn" | "error" | "log" = "log",
) => {
  if (
    typeof process !== "undefined" &&
    process.env?.NODE_ENV === "development"
  ) {
    console[loggerType](message, valueToLog);
  }
};

export const logError = (error: Error, additionalInfo: unknown = "") => {
  if (
    error instanceof ReferenceError &&
    error.message.includes("localStorage")
  ) {
    return;
  }

  if (
    typeof process !== "undefined" &&
    process.env?.NODE_ENV === "development"
  ) {
    console.error(
      "Error:",
      error.message,
      "\nStack Trace:",
      error.stack,
      "\nAdditional Info:",
      additionalInfo,
    );
  }
};
